import { Theme } from '@emotion/react';
import styled from '@emotion/styled';

type Override = (theme: Theme) => Record<string, any>;

interface Props {
    isOpen: boolean;
    isImage?: boolean;
    onClick?: () => void;
    icon: string;
    collapsedContent?: React.ReactNode;
    children?: React.ReactNode;
    selected?: boolean;
    styleOverride?: Override;
    iconStyleOverride?: Override;
    ariaLabel: string;
    className?: string;
    id?: string;
}

const Icon = styled.div<{ src: string; isImage: boolean; override?: Override }>`
    width: 4rem;
    height: 4rem;
    flex-shrink: 0;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    transition: transform 0.3s ease-in-out;

    &::after {
        content: '';
        display: block;
        background-color: ${({ theme }) => theme.colors.black[300]};
        ${({ isImage, src }) => (isImage ? `background: url(${src}) no-repeat center;` : `mask: url(${src}) no-repeat center;`)}
        background-size: cover;
        width: 100%;
        height: 100%;
    }

    ${({ override, theme }) => override?.(theme)}
`;

const CustomButton = styled.button<{ selected?: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    border: none;
    padding: 0.75rem 0;
    outline: none;
    cursor: pointer;
    white-space: nowrap;
    gap: 1rem;
    font-weight: 600;
    font-size: 1.6rem;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.colors.black[50]};
    background: ${({ selected, theme }) => (selected ? theme.colors.black.main : 'transparent')};
    overflow: hidden;
    border-radius: 12px;

    &:focus {
        outline: none;
    }
`;

export default function ({
    children,
    id,
    isOpen,
    onClick,
    icon,
    collapsedContent,
    selected,
    iconStyleOverride,
    isImage = false,
    ariaLabel,
    className,
}: Props) {
    return (
        <CustomButton id={id} className={className} selected={selected} onClick={onClick} aria-label={ariaLabel}>
            <Icon className="sidebar_button_icon" src={icon} override={iconStyleOverride} isImage={isImage} />
            {isOpen ? children : collapsedContent}
        </CustomButton>
    );
}
